<template>
    <div class="edit-container" :class="externalClass">
        <quill-editor
            :id="'editor' + quillId"
            ref="quillEditor"
            v-model="content"
            class="quill-editor-box"
            :options="editorOption"
            @blur="onEditorBlur"
            @focus="onEditorFocus"
            @ready="onEditorReady"
            @change="onEditorChange"
        >
        </quill-editor>
        <div v-show="false">
            <Upload
                ref="uploadAdd"
                accept="image/jpeg,image/jpg,image/bmp,image/png"
                name="file"
                type="drag"
                :data="{fieldNames}"
                :format="[
                    'jpeg',
                    'jpg',
                    'bmp',
                    'png',
                    'JPEG',
                    'JPG',
                    'BMP',
                    'PNG',
                ]"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                :on-exceeded-size="uploadSize"
                :is-default-upload="false"
                :max-size="1024 * 5"
                :action="url"
                :show-upload-list="false"
                :on-format-error="uploadFormatError"
            >
            </Upload>
        </div>
    </div>
</template>

<script>
/**
 * @desc 编辑器 组件
 * @author baibangyi<baibangyi@baidu.com>
 * @file customize-editor
 */

export default {
    props: {
        quillPlaceholder: {
            type: String,
            default: '请在这里输入'
        },
        quillToolbar: {
            type: Array,
            default: () => [['image']]
        },
        quillId: {
            type: Number,
            default: 0
        },
        uploadUrl: {
            type: String,
            default: '/bp/api/upload?ajax=1&bdstoken='
        },
        fieldNames: {
            type: String,
            default: 'paragraphImage'
        },
        externalClass: {
            type: String,
            default: ''
        },
        // 是否用默认的上传成功方法
        isDefaultUpload: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            content: '',
            url: `${this.uploadUrl}${
                window._pageData && window._pageData.bdstoken
            }`,
            editorOption: {
                placeholder: this.quillPlaceholder,
                modules: {
                    toolbar: {
                        container: this.quillToolbar,
                        handlers: {
                            image: value => {
                                if (value) {
                                    // 触发上传事件
                                    this.$refs.uploadAdd.handleClick();
                                }
                                else {
                                    this.$refs.quillEditor.quill.format(
                                        'image',
                                        false
                                    );
                                }
                            }
                        }
                    }
                }
            },
            canSetContent: false
        };
    },
    computed: {
        editor() {
            return this.$refs.quillEditor.quill;
        }
    },
    methods: {
        // 失去焦点事件
        onEditorBlur() {
            let delta = this.$refs.quillEditor.quill.getContents();
            let txts = this.$refs.quillEditor.quill.getText();
            let innerHTML = this.$refs.quillEditor.quill.root.innerHTML;
            this.$emit('editor-blur', delta, txts, this.quillId, innerHTML);
        },
        onEditorReady(quill) {
            // 编辑器ready
            this.canSetContent = true;
        },
        // 获得焦点事件
        onEditorFocus() {
            this.$emit('editor-focus', this.quillId);
        },
        // 内容改变事件
        onEditorChange() {
            let innerHTML = '';
            let length = 0;
            try {
                innerHTML = this.$refs.quillEditor.quill.root.innerHTML;
                // 字数统计，总是存在一个\n，需要减1
                length = this.$refs.quillEditor.quill.getLength();
                length > 0 && (length -= 1);
            }
            catch (error) {}
            this.$emit('editor-change', {
                innerHTML,
                length
            });
        },
        // 设置内容
        setContent(content) {
            if (this.canSetContent) {
                this.$refs.quillEditor.quill.setContents(content);
                this.content = content;
            }
        },
        uploadFormatError() {
            this.$Message.error({
                content: '文件格式错误,支持jpeg、jpg、bmp、png文件',
                duration: 5
            });
        },
        uploadSuccess(res) {
            const vm = this;
            if (+res?.code !== 0) {
                return;
            }
            if (!this.isDefaultUpload) {
                res = this.$normalizeResponseData(res);
            }
            const resultUrl = res?.bos_url || res?.data?.bos_url || res?.picInfo?.url || '';
            vm.editor.insertEmbed(
                vm.editor.getSelection().index,
                'image',
                resultUrl
            );
        },
        uploadSize() {
            this.$Message.error({
                content: '上传失败，图片大小不能超过5M',
                duration: 5
            });
        },
        uploadError(err) {
            this.$Message.error({
                content: '文件上传失败，请检查网络再尝试',
                duration: 5
            });
        }
    }
};
</script>

<style lang="less" scoped>
.edit-container {
    width: 730px;
}
// 深度选择器
/deep/ .ql-container {
    width: 730px;
    height: 230px;
}

/deep/ .ql-editor p {
    img {
        width: 40%;
        height: 40%;
    }
}

.case-editor {
    width: 600px;

    /deep/ .ql-container {
        width: 600px;
        height: 252px;
    }
}
</style>